import { memo, useMemo } from "react";
import { MessageSegment } from "../utils/messages";
import { cn } from "@/lib/utils";
import { Search, ExternalLink } from "lucide-react";

interface ChatMessageProps {
  block: MessageSegment;
}

export const SearchGroundingSourcesChatMessage = memo(
  ({ block }: ChatMessageProps) => {
    const { urlSources, hasUrlSources } = useMemo(() => {
      try {
        const parsedJson = block.parsedJson;
        const searchGroundingSources = parsedJson?.searchGroundingSources || [];
        const urlSources = searchGroundingSources.filter(
          (source) => source.sourceType === "url"
        );

        return {
          urlSources,
          hasUrlSources: urlSources.length > 0,
        };
      } catch (error) {
        console.error("Failed to parse Search Grounding Sources JSON:", error);
        return {
          urlSources: [],
          hasUrlSources: false,
        };
      }
    }, [block.parsedJson]);

    if (!hasUrlSources) return null;

    return (
      <div className="flex flex-col grow bg-secondary-n-900 px-3 py-2.5 rounded-md">
        <div className="flex items-center gap-2 mb-2">
          <Search className="h-4 w-4 stroke-purple-500" />
          <span className="text-xs font-medium text-secondary-n-300">
            Search Sources
          </span>
        </div>
        <div className="flex flex-col gap-1">
          {urlSources.map((source, index) => (
            <a
              key={source.id || index}
              href={source.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-start gap-1 px-2 py-1.5 rounded-sm hover:bg-secondary-n-800 transition-colors"
            >
              <div className="flex-shrink-0 mt-0.5">
                <ExternalLink className="h-3.5 w-3.5 stroke-secondary-n-400 group-hover:stroke-blue-400" />
              </div>
              <span className="text-xs text-secondary-n-300 group-hover:text-blue-400 leading-snug">
                {source.title}
              </span>
            </a>
          ))}
        </div>
      </div>
    );
  }
);
